
//
const disableOnSubmitForms = document.querySelectorAll('form[data-disable-on-submit]');

//
if (disableOnSubmitForms != null && disableOnSubmitForms.length > 0) {
    for (const disableOnSubmitForm of disableOnSubmitForms) {
        disableOnSubmitForm.addEventListener('submit', (event) => {
            const submitButtons = disableOnSubmitForm.querySelectorAll('button:not([type="button"]):not([type="reset"])');
            if (submitButtons !== null && submitButtons.length > 0) {
                for (const submitButton of submitButtons) {
                    submitButton.setAttribute('disabled', 'disabled');
                }
            }
        });
    }
}